import { render } from "./Home.vue?vue&type=template&id=272881a0&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=272881a0&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272881a0"]])

export default __exports__